import React from 'react'
import SearchForm from "../../shared/components/searchForm/SearchForm"
import { timesearchFields } from '../utils/timesearchFields';
import { appModules } from '../../roles/components/UserHasPermission';
import ReactHighcharts from 'highcharts-react-official';
import HighCharts from 'highcharts';

const GraphsForBillingPage = ({
    searchGraphFieldsValues,
    hideGraphAddButton,
    handleGraphSearchFieldChange,
    handleGraphSearchSubmit,
    handleGraphSearchClear,
    hideGraphUniversalSearch,
    min,
    max,
    startDatemaxValue,
    activeDataArray,
    inactiveDataArray,
    disconnectedDataArray,
    showDays,

   
}) => {
   /*  console.log("hideGraphUniversalSearch", hideGraphUniversalSearch)
    console.log("searchGraphFieldsValues", searchGraphFieldsValues)
    console.log("min", min)
    console.log("activeDataArray", activeDataArray) */
    
    const getOptions = ({
        title: {
            text: "Historical Data"
        },
        navigation: {
            buttonOptions: {
                /*  enabled: false */
            }
        },
        credits: {
            enabled: false
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['downloadPNG', 'downloadJPEG',"downloadSVG", "downloadPDF", "separator", "downloadCSV"]
                }
            }
        },
        chart: {
            type: 'line',
            margin: [75, 50, 100, 75],
            plotBorderWidth: 2,
            series: {
                borderRadiusTopLeft: '50%',
                borderRadiusTopRight: '50%'
            },
            exporting: { enabled: false },
        },
        series: [{
            name: "Active rooms",
           color:"rgb(148, 206, 84)",
            data:   activeDataArray, 
           /*  data:[0,70,90,40,10, 0,70,50,40,10, 0,30,50,40,60, 0,20,50,40,70, 0,30,50,80,90, 0,30,50,40,70,90], */
            marker: {
                symbol: "circle"
            }
        },
        {
            name: "Inactive rooms",
           color: "rgb(175, 198, 225)",
            data:  inactiveDataArray, 
           /*  data:[0,30,50,40,60, 0,30,50,40,60, 0,30,50,40,60, 0,30,50,40,60, 0,30,50,40,60, 0,30,50,40,60,60], */
            marker: {
                symbol: "square",
            }
        },
        {
            name: "Disconnected rooms",
            color: "rgb(209, 118, 129)",
            dashStyle: 'Dash',
            lineColor: 'rgb(209, 118, 129)',
            marker: {
                enabled: false,
            },
           /*  data:[0,60,90,70,80, 70,70,50,40,10, 20,30,50,40,60, 60,80,50,40,70, 90,30,50,40,90, 10,30,50,70,20,90], */
            data: disconnectedDataArray,
        },
        ],
        xAxis: {
            lineWidth: 1.5,
            lineColor: '#000000',
            tickWidth: .5,
            tickLength: 7,
            tickColor: '#000000',
            categories: showDays
        },
        yAxis: {
            /*  gridLineColor:'rgba(204,204,204,.25)',
             gridLineWidth:0.5, */
            lineWidth: 1.5,
            lineColor: '#000000',
            tickWidth: .5,
            tickLength: 7,
            tickColor: '#000000',
            title: {
                text: "Number of rooms"
            },

        }
    })

    return (<>
        <div className="page_background" style={{ marginTop: "70px" }}>
            <SearchForm
                content={timesearchFields(searchGraphFieldsValues, min, max, startDatemaxValue)}
                hideAddButton={hideGraphAddButton}
                handleFieldChange={handleGraphSearchFieldChange}
                handleSubmit={handleGraphSearchSubmit}
                handleClear={handleGraphSearchClear}
                hideUniversalSearch={hideGraphUniversalSearch}

            />
        </div>


        <ReactHighcharts highcharts={HighCharts}
            options={{ ...getOptions }} />
        <div >

        </div>

    </>)
}
export default GraphsForBillingPage